module.exports = __webpack_public_path__ + "static/img/p7.eb8bdcef.png";